<div class="ahe-ui form-group search-container" role="search">
  <app-input
    #searchInput
    [id]="'searchfilter'"
    [label]="'Search by Test Title'"
    [hideLabel]="true"
    [placeholder]="'Search by Test Title'"
    [(ngModel)]="searchText"
    (ngModelChange)="dataChanged(searchText)"
    [error]="false"
    [icon]="'search'"
    [value]="searchText"
  >
  </app-input>
  <button 
    appTooltip="Clear Search"
    *ngIf="searchText"
    id="clear-search-btn"
    class="clear-input"
    (click)="clearSearch()"
    (keydown.enter)="clearSearch()"
    (keydown.space)="clearSearch()"
    type="button"
    aria-label="Clear Search"
    [attr.aria-describedby]="'searchfilter'"
  >
    <i class="dpg-icon dpg-icon-system-close" aria-hidden="true"></i>
  </button>
</div>
